"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _templateObject;

var StyledIcon = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  ", "\n  ", "\n  ", "\n  svg {\n    vertical-align: middle;\n  }\n  ", "\n"])), function (props) {
  return props.onClick && "\n    cursor: pointer;\n  ";
}, function (props) {
  return props.hoverColor && "\n    &:hover {\n      svg {\n        path {\n          fill: ".concat(props.hoverColor, ";\n        }\n      }\n    }\n  ");
}, function (props) {
  return props.padding && "\n    padding: ".concat(props.padding, " !important;\n  ");
}, _styledSystem.space);

exports.StyledIcon = StyledIcon;